import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Point} from '../models/point';
import {config} from '../../shared/config';
import { map, shareReplay, tap } from 'rxjs/operators';
import { PointsSummary } from '../models/points-summary';
import { BaseHttpService } from '../../core/services/base-http.service';
import { StorageService } from '../../core/storage/storage.service';

@Injectable({
  providedIn: 'root'
})
export class PointsService extends BaseHttpService {
  private _observables: {[key: string]: Observable<Point>} = {};
  constructor(
    protected _http: HttpClient,
    protected _storage: StorageService,
  ) {
    super(_http, _storage);
  }

  getPoint(unitId:number , routeStartDate:string, dateTime:string, routeEndDate:string ): Observable<Point>{
    const url = `Points/details/unit/${unitId}/route/${routeStartDate}/${dateTime}/${routeEndDate}`;
    if (this._observables[url]) {
      return this._observables[url];
    }
    this._observables[url] = this.get(config.generateApiUrl( url, ['*'], null, 2.2), { headers: { ignoreLoadingBar: 'true' } }).pipe(
      shareReplay(1),
      map(response => response['data'])
    );
    return this._observables[url];
  }
  getPoints(id: number, from: string, to: string): Observable<PointsSummary> {
    const fields = ['*'];
    const url = `Points/unit/${id}/summary?From=${from}&To=${to}`
    return this.get(config.generateApiUrl( url, fields, null, 2.2), { headers: { ignoreLoadingBar: 'true' } }).pipe(
      map(response => response['data'] as PointsSummary),
      tap(data => data.points.forEach((point, index) => point.pointId = index + 1)),
    );
  }
}
